<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 5C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8C2 6.34315 3.34315 5 5 5H19ZM19 7H5C4.44772 7 4 7.44772 4 8V16C4 16.5523 4.44772 17 5 17H19C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7ZM8 13V15H6V13H8ZM18 13V15H16V13H18ZM15 13V15H9V13H15ZM8 9V11H6V9H8ZM11 9V11H9V9H11ZM14 9V11H12V9H14ZM18 9V11H15V9H18Z"
    fill="currentColor"
  />
</svg>
